import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import { makeStyles, Theme } from '@material-ui/core/styles'
import { CSSProperties } from '@material-ui/core/styles/withStyles'

// Harmony's hover/active tint, reused by every light-header icon control.
export const harmonyHoverColors = (theme: Theme): CSSProperties => ({
    backgroundColor: theme.harmony.colors.hoverBg,
    color: theme.harmony.colors.brandMain,
})

export const harmonyActiveColors = (theme: Theme): CSSProperties => ({
    backgroundColor: theme.harmony.colors.activeBg,
    color: theme.harmony.colors.brandMain,
})

// Shared 40px pill shape used by Home/Maps/Studio and, via HarmonyPopoverTrigger, Help/Notifications.
export const harmonyIconButtonBase = (theme: Theme): CSSProperties => ({
    width: pxToRem(40),
    height: pxToRem(40),
    padding: theme.harmony.spacing.sm,
    borderRadius: '999px',
    color: theme.harmony.colors.textHeader,
    transition: 'background 150ms ease',
})

// Shared dropdown-menu shadow for every Harmony popover panel (user menu, help, notifications,
// firm switcher). Lives here rather than AppHeader.styles.ts so that file can import it without
// creating a circular dependency (it already imports from this module).
export const HARMONY_MENU_SHADOW = '0 8px 24px rgba(42, 52, 71, 0.16)'

export const harmonyPopoverPaper = (theme: Theme): CSSProperties => ({
    borderRadius: '8px',
    boxShadow: HARMONY_MENU_SHADOW,
})

/**
 * Harmony light-header icon button classes, shared by every popover/nav-icon trigger in the
 * header (Home/Maps/Studio via AppHeader.tsx, Help/Notifications via HarmonyPopoverTrigger).
 */
export const useHarmonyIconButtonStyles = makeStyles((theme: Theme) => ({
    iconButton: {
        ...harmonyIconButtonBase(theme),
        '&:hover': harmonyHoverColors(theme),
    },
    iconButtonActive: {
        ...harmonyActiveColors(theme),
        '&:hover': harmonyActiveColors(theme),
    },
    icon: {
        width: pxToRem(24),
        height: pxToRem(24),
    },
    focusRing: {
        '&:focus-visible': {
            outline: `2px solid ${theme.harmony.colors.focusRing}`,
            outlineOffset: pxToRem(2),
        },
    },
}))
